const rateCategoriesUrl = '/rate-categories';

export default {
    /**
     *
     * @returns {Promise<Array>}
     * Return list of taxes
     */
    async getAllRateCategories(offset = 0) {
        const params = {
            limit: 100,
            offset,
            embed: ['currency'],
        };
        const rateCategoriesResult = [];
        let result = await ApiClient.get(rateCategoriesUrl, params);
        rateCategoriesResult.push(...result.data.data);
        while (rateCategoriesResult.length < result.data.pagination.total) {
            params.offset = rateCategoriesResult.length;
            result = await ApiClient.get(rateCategoriesUrl, params);
            rateCategoriesResult.push(...result.data.data);
        }
        return rateCategoriesResult;
    },
    postRateCategory(payload) {
        return new Promise((resolve, reject) => {
            ApiClient.post(rateCategoriesUrl, { embed: ['currency'] }, payload)
                .then((response) => {
                    if (response.status !== 201) {
                        reject();
                    }
                    resolve(response.data);
                })
                .catch((err) => reject(err));
        });
    },
    updateRateCategory(payload, id) {
        return new Promise((resolve, reject) =>
            ApiClient.put(`${rateCategoriesUrl}/${id}`, { embed: ['currency'] }, payload)
                .then((response) => {
                    if (response.status !== 200) {
                        reject();
                    }
                    resolve(response.data);
                })
                .catch((err) => reject(err)),
        );
    },
    deleteRateCategory(id) {
        return new Promise((resolve, reject) =>
            ApiClient.del(`${rateCategoriesUrl}/${id}`)
                .then((response) => {
                    if (response.status !== 204) {
                        reject();
                    }
                    resolve(response.data);
                })
                .catch((err) => reject(err)),
        );
    },
    getRateCategoriesMetadata() {
        return new Promise((resolve, reject) =>
            ApiClient.get(`${rateCategoriesUrl}/metadata`, {})
                .then((response) => {
                    if (response.status !== 200) {
                        reject();
                    }
                    resolve(response.data);
                })
                .catch((err) => reject(err)),
        );
    },
};
